export default __webpack_public_path__ + "static/media/miguel-lopes-13.c49bd0f6.jpg";